import { Avatar, Anchor, Box, Button, Header, InfiniteScroll, Image } from 'grommet';
import { Bookmark, Contact, Favorite, More } from 'grommet-icons'
import adam from './profiles/adam';
import jackson from './profiles/jackson';
import shiv from './profiles/shiv';
import tom from './profiles/tom';

const CardHeader = ({ user }) => {
    return (
        <Header
            fill="horizontal"
            justify='between'
        >
            <Box direction='row' gap='medium'>
                <Button
                    icon={<Avatar src={user.profilePicture} />}
                />
                <Anchor alignSelf='center' textAlign='justify'>{user.username}</Anchor>
            </Box>
            <Box direction='row'>
                <Button icon={<More />}>
                </Button>
            </Box>
        </Header>
    )
}

const CardFooter = () => {
    return (
        <Header
            fill="horizontal"
            justify='between'
        >
            <Box direction='row' gap='medium'>
                <Button
                    icon={<Favorite />}
                />
                <Button
                    icon={<Contact />}
                />
            </Box>
            <Box direction='row'>
                <Button icon={<Bookmark />}>
                </Button>
            </Box>
        </Header>
    )
}

const InfiniteFeed = () => {
    return (
        <Box gap='large' overflow='auto' margin='auto' fill>
            <InfiniteScroll items={[adam, jackson, shiv, tom]}>
                {(item) => (
                    <Box
                        gap="large"
                        alignSelf="center"
                        pad={{top: 'large', bottom: 'large'}}
                        border='between'
                        flex={false}
                        key={item.key}
                    >
                        <CardHeader user={item}/>
                        <Box height='large' width='large'>
                            <Image
                                fit='cover'
                                src="//v2.grommet.io/assets/Wilderpeople_Ricky.jpg"
                            />
                        </Box>
                        <CardFooter />
                    </Box>
                )}
            </InfiniteScroll>
        </Box>
    )
}

const Feed = ({content}) => {
    return (
       <InfiniteFeed content={content}/>
    )
}

export default Feed;